import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { getHumanUrl } from "../../utils";
import Avatar from "../../components/Avatar";

function HumanAvatar({ image, name, humanId }) {
  return (
    !!name && (
      <Link
        to={humanId && getHumanUrl({ id: humanId, name })}
        style={{ textDecoration: "none" }}
      >
        <Avatar size="2rem" human={{ name: name, image: image }} />
      </Link>
    )
  );
}

HumanAvatar.propTypes = {
  image: PropTypes.any,
  name: PropTypes.string,
  humanId: PropTypes.string,
};

export default HumanAvatar;
